import { Ipage } from 'components/Table/type';
import { Ioption } from 'tradevan-ui/type';
import { EnumRetailerSetup, EnumRetailerType } from 'view/Layout/enum';
import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import { useSelector } from 'react-redux';
import { localStorageRetaierIdName } from 'consts';
import { IexportItemList, IqueryDateList, IquerySort } from 'view/Layout/type';
import { initExportItemList } from 'view/Layout/consts';

// #region Master

export const EnumMaster = {
  /** 體系別 */
  retailerId: 'retailerId',
  /** 廠編 */
  supplierCode: 'supplierCode',
  /** 分店/倉庫代碼 */
  storeNo: 'storeNo',
  /** 退貨驗收日期 起 */
  returnStartDate: 'returnStartDate',
  /** 退貨驗收日期 訖 */
  returnEndDate: 'returnEndDate',
  /** 退貨驗收單號碼 起 */
  returnStartNo: 'returnStartNo',
  /** 退貨驗收單號碼 訖 */
  returnEndNo: 'returnEndNo',
  /** 退貨通知日期 起 */
  returnNoteStartDate: 'returnNoteStartDate',
  /** 退貨通知日期 訖 */
  returnNoteEndDate: 'returnNoteEndDate',
  /** 退貨通知單號碼 起 */
  returnNoteStartNo: 'returnNoteStartNo',
  /** 退貨通知單號碼 訖 */
  returnNoteEndNo: 'returnNoteEndNo',
  /** 退貨單狀態 */
  returnStat: 'returnStat',
  /** 廠編模糊篩選 */
  supplierCodeLike: 'supplierCodeLike',
  /** 日期下拉選單 */
  queryDateValue: 'queryDateValue',
  /** 動態日期 起 */
  queryDateBegin: 'queryDateBegin',
  /** 動態日期 迄 */
  queryDateEnd: 'queryDateEnd',
} as const;

export interface Imaster {
  [EnumMaster.retailerId]: EnumRetailerType | string;
  [EnumMaster.supplierCode]: string[];
  [EnumMaster.storeNo]: string[];
  [EnumMaster.returnStartDate]: Date | null;
  [EnumMaster.returnEndDate]: Date | null;
  [EnumMaster.returnStartNo]: string;
  [EnumMaster.returnEndNo]: string;

  [EnumMaster.returnNoteStartDate]: Date | null;
  [EnumMaster.returnNoteEndDate]: Date | null;
  [EnumMaster.returnNoteStartNo]: string;
  [EnumMaster.returnNoteEndNo]: string;
  [EnumMaster.returnStat]: string[];
  [EnumMaster.supplierCodeLike]: string;

  [EnumMaster.queryDateValue]: string | null;
  [EnumMaster.queryDateBegin]: Date | null;
  [EnumMaster.queryDateEnd]: Date | null;
}

// #endregion

// #region Detail

export enum EnumDetail {
  /** 體系別 */
  retailerId = 'retailerId',
  /** 體系別中文 */
  retailerName = 'retailerName',
  /** 分店/倉庫名稱 */
  buyerGLN = 'buyerGLN',
  /** 倉庫名稱 */
  postBriefName = 'postBriefName',
  /** 退貨通知單號碼 */
  returnNoteNo = 'returnNoteNo',
  /** 退貨驗收單號碼 */
  returnNo = 'returnNo',
  /** 退貨通知日期 */
  returnNoteDate = 'returnNoteDate',
  /** 退貨驗收日期 */
  deliverEndDate = 'deliverEndDate',
  /** 廠編 */
  supplierCode = 'supplierCode',
  /** 廠商簡稱 */
  supplierBriefName = 'supplierBriefName',
  /** 點閱紀錄		    */
  viewed = 'viewed',
  /** 文字檔下載紀錄 */
  downloaded = 'downloaded',
  /** 最後異動時間 */
  updDate = 'updDate',
  /** 備註 */
  generalInfo = 'generalInfo',
  /** 結帳日 */
  closeDate = 'closeDate',
  // 以下沒用到
  propName = 'propName',
  returnDate = 'returnDate',
  storeNo = 'storeNo',
  transDate = 'transDate',
  returnSeqNo = 'returnSeqNo',
  returnExpireDate = 'returnExpireDate',
  deliverStartDate = 'deliverStartDate',
  deliverStartTime = 'deliverStartTime',
  deliverEndTime = 'deliverEndTime',
  upFlag = 'upFlag',
  rtnAmount = 'rtnAmount',
  rtnTaxAmount = 'rtnTaxAmount',
  returnStat = 'returnStat',
}

export interface Idetail {
  selected: boolean;
  [EnumDetail.retailerId]: string;
  [EnumDetail.retailerName]: string;
  [EnumDetail.buyerGLN]: string;
  [EnumDetail.postBriefName]: string;
  [EnumDetail.returnNoteNo]: string;
  [EnumDetail.returnNo]: string;
  [EnumDetail.returnNoteDate]: string;
  [EnumDetail.deliverEndDate]: string;
  [EnumDetail.supplierCode]: string;
  [EnumDetail.supplierBriefName]: string;
  [EnumDetail.viewed]: string;
  [EnumDetail.downloaded]: string;
  [EnumDetail.updDate]: string;
  // 以下沒用到
  [EnumDetail.propName]: string;
  [EnumDetail.returnDate]: string;
  [EnumDetail.buyerGLN]: string;
  [EnumDetail.storeNo]: string;
  [EnumDetail.transDate]: string;
  [EnumDetail.returnSeqNo]: string;
  [EnumDetail.returnExpireDate]: string;
  [EnumDetail.deliverStartDate]: string;
  [EnumDetail.deliverStartTime]: string;
  [EnumDetail.deliverEndTime]: string;
  [EnumDetail.upFlag]: string;
  [EnumDetail.rtnAmount]: string;
  [EnumDetail.rtnTaxAmount]: string;
  [EnumDetail.returnStat]: string;
  [EnumDetail.generalInfo]: string;
  [EnumDetail.closeDate]: string;
}
// #endregion

// #region MasterSort

// #endregion

// #region RetailerSetup

export interface IretailerSetupRtn {
  [EnumRetailerSetup.queryConditions]: IqueryConditions;
  [EnumRetailerSetup.queryResults]: IqueryResults;
  [EnumRetailerSetup.exportItemList]: IexportItemList;
  [EnumRetailerSetup.queryDateList]: IqueryDateList[];
}

/** retailerSetup FORM表單 */
export enum EnumQueryConditions {
  /** 下載檔案按鈕(物流中心退取須知) */
  extBtn = 'extBtn',
  retailerId = 'retailerId',
  supplierCode = 'supplierCode',
  storeNo = 'storeNo',
  returnDate = 'returnDate',
  returnNo = 'returnNo',
  /** 退貨通知日期 */
  returnNoteDate = 'returnNoteDate',
  /** 退貨通知單號碼 */
  returnNoteNo = 'returnNoteNo',
  /** 退貨單狀態 */
  returnStat = 'returnStat',
  /** 廠編模糊查詢 */
  supplierCodeLike = 'supplierCodeLike',
  /** 日期下拉選單 */
  queryDateSelect = 'queryDateSelect',
}
/** retailerSetup TABLE COL */
export enum EnumQueryResults {
  checkbox = 'checkbox',
  retailerId = 'retailerId',
  storeNo = 'storeNo',
  returnNoteNo = 'returnNoteNo',
  returnNo = 'returnNo',
  returnNoteDate = 'returnNoteDate',
  returnDate = 'returnDate',
  supplierCode = 'supplierCode',
  supplierBriefName = 'supplierBriefName',
  viewed = 'viewed',
  downloaded = 'downloaded',
  updDate = 'updDate',
  returnStat = 'returnStat',
  closeDate = 'closeDate',
  generalInfo = 'generalInfo',
}

export interface IqueryConditions {
  [EnumQueryConditions.extBtn]: boolean;
  [EnumQueryConditions.retailerId]: boolean;
  [EnumQueryConditions.supplierCode]: boolean;
  [EnumQueryConditions.storeNo]: boolean;
  [EnumQueryConditions.returnDate]: boolean;
  [EnumQueryConditions.returnNo]: boolean;
  [EnumQueryConditions.returnNoteDate]: boolean;
  [EnumQueryConditions.returnNoteNo]: boolean;
  [EnumQueryConditions.returnStat]: boolean;
  [EnumQueryConditions.supplierCodeLike]: boolean;
  [EnumQueryConditions.queryDateSelect]: boolean;
}

export interface IqueryResults {
  [EnumQueryResults.checkbox]: boolean;
  [EnumQueryResults.retailerId]: boolean;
  [EnumQueryResults.storeNo]: boolean;
  [EnumQueryResults.returnNoteNo]: boolean;
  [EnumQueryResults.returnNo]: boolean;
  [EnumQueryResults.returnNoteDate]: boolean;
  [EnumQueryResults.returnDate]: boolean;
  [EnumQueryResults.supplierCode]: boolean;
  [EnumQueryResults.supplierBriefName]: boolean;
  [EnumQueryResults.viewed]: boolean;
  [EnumQueryResults.downloaded]: boolean;
  [EnumQueryResults.updDate]: boolean;
  [EnumQueryResults.returnStat]: boolean;
  [EnumQueryResults.closeDate]: boolean;
  [EnumQueryResults.generalInfo]: boolean;
}

// #region retailerSetup 控制畫面顯示
export const useInitRetailerSetup = (): IretailerSetupRtn => ({
  [EnumRetailerSetup.queryConditions]: {
    /** 體系別 */
    [EnumQueryConditions.retailerId]: true,
    [EnumQueryConditions.extBtn]: false,
    [EnumQueryConditions.supplierCode]: false,
    [EnumQueryConditions.storeNo]: false,
    [EnumQueryConditions.returnDate]: false,
    [EnumQueryConditions.returnNo]: false,
    [EnumQueryConditions.returnNoteDate]: false,
    [EnumQueryConditions.returnNoteNo]: false,
    [EnumQueryConditions.returnStat]: false,
    [EnumQueryConditions.supplierCodeLike]: false,
    [EnumQueryConditions.queryDateSelect]: false,
  },
  [EnumRetailerSetup.queryResults]: {
    [EnumQueryResults.checkbox]: true,
    [EnumQueryResults.retailerId]: true,
    [EnumQueryResults.storeNo]: true,
    [EnumQueryResults.returnNoteNo]: true,
    [EnumQueryResults.returnNo]: true,
    [EnumQueryResults.returnNoteDate]: true,
    [EnumQueryResults.returnDate]: true,
    [EnumQueryResults.supplierCode]: false,
    [EnumQueryResults.supplierBriefName]: false,
    [EnumQueryResults.viewed]: false,
    [EnumQueryResults.downloaded]: false,
    [EnumQueryResults.updDate]: true,
    [EnumQueryResults.returnStat]: false,
    [EnumQueryResults.closeDate]: false,
    [EnumQueryResults.generalInfo]: false,
  },
  [EnumRetailerSetup.exportItemList]: initExportItemList,
  [EnumRetailerSetup.queryDateList]: [],
});
// #endregion

// #region Form

export interface RtnQueryForm {
  master: Imaster;
  masterSort: IquerySort[];
  detail: Idetail[];
}

export interface RtnQueryFormDetail {
  master: Imaster;
  detail: Idetail[];
  pageObj: Ipage;
  masterSort: IquerySort[];
}

// #endregion

// #region state

export interface RtnQueryState {
  /** input */
  master: Imaster;
  /** form的排序 */
  masterSort: IquerySort[];
  detail: Idetail[];
  pageObj: Ipage;
  /** 體系別option */
  retailerTypeOption: Ioption[];
  showResult: boolean;
  /** 操作歷程 畫面開關 */
  showLogRecordModal: boolean;
  /** 操作歷程 資料 */
  logRecordData: IlogRecordQuery[];
  queryDateList: IqueryDateList[];
}

export enum EnumQueryDateSelect {
  選項值 = 'optionId',
  選項名稱 = 'propertyName',
  預設起始天數 = 'beginDate',
  預設結束天數 = 'endDate',
}

// #endregion

// #region useInit
export const useInitMaster = (): Imaster => {
  // 取得 retailerIds (動態變動) 所以要使用 useEffect 更新 Master
  const { retailerIds } = useSelector(getUserInfoReducer);
  // 舊系統轉移到新系統，retaierId會記錄到 localStorage
  // 如果沒有 localStorage 就取 retailerIds 的第一比當體系別預設值
  const defaultRetaierId =
    localStorage.getItem(localStorageRetaierIdName) ||
    retailerIds?.[0]?.retailerId ||
    '';
  return {
    [EnumMaster.retailerId]: defaultRetaierId,
    [EnumMaster.supplierCode]: [],
    [EnumMaster.storeNo]: [],
    [EnumMaster.returnStartDate]: new Date(),
    [EnumMaster.returnEndDate]: new Date(),
    [EnumMaster.returnStartNo]: '',
    [EnumMaster.returnEndNo]: '',
    [EnumMaster.returnNoteStartDate]: new Date(),
    [EnumMaster.returnNoteEndDate]: new Date(),
    [EnumMaster.returnNoteStartNo]: '',
    [EnumMaster.returnNoteEndNo]: '',
    [EnumMaster.returnStat]: [],
    [EnumMaster.supplierCodeLike]: '',
    [EnumMaster.queryDateValue]: '',
    [EnumMaster.queryDateBegin]: new Date(),
    [EnumMaster.queryDateEnd]: new Date(),
  };
};

// #endregion
